/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FlexCell',
  props: {
    link: {
      type: Boolean,
      "default": false
    },
    bottomLine: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {};
  },
  methods: {}
};